import { SQUAD_DEFAULTS } from '../constants/squad';

/**
 * Минимум участников для запуска отряда: max(ceil(capacity × ratio), minPlay), но не больше capacity.
 * BLUEPRINT 3.5 / ADR-8: падел 8 → 6, футбол 10 → 8, волейбол 12 → 9, теннис 2 → 2, 4 → 3.
 */
export function minToLaunchFor(
  capacity: number,
  minPlay: number,
  ratio: number = SQUAD_DEFAULTS.minToLaunchRatio,
): number {
  if (!Number.isInteger(capacity) || capacity < 1) {
    throw new Error(`minToLaunchFor: capacity должен быть целым ≥ 1, получено ${capacity}`);
  }
  if (!Number.isInteger(minPlay) || minPlay < 0) {
    throw new Error(`minToLaunchFor: minPlay должен быть целым ≥ 0, получено ${minPlay}`);
  }
  const byRatio = Math.ceil(capacity * ratio - 1e-9);
  return Math.min(capacity, Math.max(byRatio, minPlay));
}

export interface HasSizeOptions {
  sizeOptions: readonly number[];
}

/** Размер отряда допустим для активности (`size ∈ activity.sizeOptions`). */
export function isValidSize(activity: HasSizeOptions, size: number): boolean {
  return Number.isInteger(size) && activity.sizeOptions.includes(size);
}

/** Размер отряда для неосновной активности или когда выбор не сделан. */
export function defaultSizeFor(activity: HasSizeOptions): number {
  return activity.sizeOptions[0] ?? SQUAD_DEFAULTS.defaultCapacity;
}

/** Целевая явка на сбор: не меньше игрового минимума активности. */
export function minAttendanceFor(minPlay: number): number {
  return Math.max(1, minPlay);
}
